export default (englishDay: string) => {
	switch (englishDay.toLowerCase()) {
		case 'monday':
			return 'maandag';
		case 'tuesday':
			return 'dinsdag';
		case 'wednesday':
			return 'woensdag';
		case 'thursday':
			return 'donderdag';
		case 'friday':
			return 'vrijdag';
		case 'saturday':
			return 'zaterdag';
		case 'sunday':
			return 'zondag';
	}

	return englishDay;
};
